function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M18.853 18.066h-17.7a1.149 1.149 0 01-1.148-1.148V3.148A1.149 1.149 0 011.153 2h17.7a1.149 1.149 0 011.148 1.148v13.771a1.149 1.149 0 01-1.148 1.147zM1.153 2.984a.166.166 0 00-.164.164v13.771a.166.166 0 00.164.164h17.7a.166.166 0 00.164-.164V3.148a.166.166 0 00-.164-.164z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.504 16.23a.489.489 0 01-.352-.149l-4.607-4.73-2.93 2.344a.492.492 0 01-.655-.036L6.048 8.747.821 13.563a.492.492 0 11-.667-.723l5.574-5.136a.493.493 0 01.681.014l4.934 4.935 2.935-2.348a.491.491 0 01.659.041l4.918 5.049a.491.491 0 01-.352.835zm-5.24-8.323A1.148 1.148 0 1115.41 6.76a1.149 1.149 0 01-1.146 1.147zm0-1.311a.164.164 0 100 .328.164.164 0 000-.328z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z"
});

var SvgFromGallery = function SvgFromGallery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 20 20",
      width: 20,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgFromGallery, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/from_gallery.661a6445.svg";
export { ForwardRef as ReactComponent };